module.exports = __webpack_public_path__ + "static/media/NextDisabled.e40c5346.svg";